import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { ECommerceProductTemplatesFacade } from '@api-ui-app/src/app/e-commerce-product-templates/e-commerce-product-templates.facade';
import { StoreProductModeService } from '@product-catalogue/src/lib/product-catalogue/services/store-product-mode.service';
import { EProductTemplatesListItem } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-list-item';
import { EProductTemplatesSearchSortingParams } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-search-sorting-params';
import { StoreProductMode } from '@product-catalogue/src/lib/product-catalogue/lib/store-product-mode.enum';
import { ECommerceProductWizardFacade } from '@api-ui-app/src/app/e-commerce-stores/services/e-commerce-product-wizard/e-commerce-product-wizard.facade';
import { LayoutService } from '@gelato-api-ui/sdk/src/lib/shared/services/layout.service';

@Component({
  selector: 'gd-product-catalogue-templates-list-page',
  templateUrl: './product-catalogue-templates-list-page.component.html',
  styleUrls: ['./product-catalogue-templates-list-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCatalogueTemplatesListPageComponent implements OnInit, OnDestroy {
  isLoading$ = this.facade.isLoading$;
  isProcessing$ = this.facade.isProcessing$;
  itemsCount$ = this.facade.itemsCount$;
  items$ = this.facade.items$;
  templateName$ = this.facade.templateName$;
  sortingParams$ = this.facade.sortingParams$;
  storeType$ = this.eCommerceProductWizardFacade.eStoreType$;
  storeProductMode = this.storeProductModeService.getMode(this.route);
  rootPath = this.storeProductModeService.getRootPath(this.route);
  showECommerceProductWizardActionsPanel = this.storeProductMode === StoreProductMode.PRODUCT_WIZARD;
  showPlaceOrderButton = !this.storeProductMode;
  showTemplatesTab$ = this.facade.isTemplatesTabEnabledForProductSelection(this.storeProductMode);

  constructor(
    private readonly facade: ECommerceProductTemplatesFacade,
    private readonly route: ActivatedRoute,
    private readonly storeProductModeService: StoreProductModeService,
    private readonly eCommerceProductWizardFacade: ECommerceProductWizardFacade,
    private readonly layoutService: LayoutService,
  ) {}

  ngOnInit() {
    this.storeProductModeService.validateActivatedRoute(this.route).pipe(take(1)).subscribe();
    this.facade.setPageTitle();
    this.facade.load();

    if (this.storeProductMode === StoreProductMode.PRODUCT_WIZARD) {
      this.layoutService.enableFullScreenMode();
    }
  }

  ngOnDestroy() {
    this.layoutService.disableFullScreenMode();
  }

  onPlaceOrderButtonClick(item: EProductTemplatesListItem) {
    this.facade.addTemplateVariantToOrder(item?.id);
  }

  onAddToStoreButtonClick(item: EProductTemplatesListItem) {
    if (this.storeProductMode === StoreProductMode.PRODUCT_WIZARD) {
      this.facade.addTemplateToSelectedStore(item);
    } else {
      this.facade.addTemplateToStore(item);
    }
  }

  onEditButtonClick(item: EProductTemplatesListItem) {
    this.facade.editTemplate(item?.id);
  }

  onRenameButtonClick(item: EProductTemplatesListItem) {
    this.facade.renameProductTemplate(item);
  }

  onDuplicateButtonClick(item: EProductTemplatesListItem) {
    this.facade.duplicateProductTemplate(item);
  }

  onDeleteButtonClick(item: EProductTemplatesListItem) {
    this.facade.deleteProductTemplate(item);
  }

  onCreateTemplateButtonClick() {
    this.facade.createNewTemplate();
  }

  onTemplateNameChange(payload: string) {
    this.facade.setTemplateName(payload);
  }

  onSortingParamsChange(payload: EProductTemplatesSearchSortingParams) {
    this.facade.setSortingParams(payload);
  }

  onScrollDown() {
    this.facade.loadMore();
  }

  close() {
    this.eCommerceProductWizardFacade.backToProductsList(true, this.storeProductMode);
  }
}
